import React from 'react';

import updateLanguage from '../utils/updateLanguage';

export const LanguageContext = React.createContext();
export const LanguageConsumer = LanguageContext.Consumer;

export default class LanguageProvider extends React.Component {
  constructor(props) {
    super(props);
    // APP-1933 In the future we should initialize the
    // language value with 'window.navigator.language'
    this.state = {
      language: this.props.language || 'en',
    };
  }

  onUpdateLanguage = (language, user) => {
    if (language === this.state.language) return;
    this.setState({ language });
    if (!user) return;
    updateLanguage({ language, user });
  };

  render() {
    return (
      <LanguageContext.Provider
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        value={{
          language: this.state.language,
          onUpdateLanguage: this.onUpdateLanguage,
        }}
      >
        {this.props.children}
      </LanguageContext.Provider>
    );
  }
}
